import React from 'react'
import "../Loader/Loader.css";

export const Loader = () => {
  return (
    <div>Loader</div>
  )
}

export default Loader;
